import React from 'react';
import classNames from 'classnames';
import SortArrows from '@rio-cloud/rio-uikit/components/table/SortArrows';
import type { SortDirectionType } from '@rio-cloud/rio-uikit/SortDirection';


interface SortableTableHeaderProps {
  column: string;
  label: string;
  dontFilterByColums: string[];
  sortByColumn?: string;
  sortDirection?: SortDirectionType;
  handleSortChange?: (event: React.MouseEvent<HTMLTableCellElement>) => void;
}

const HIDDEN_LABELS = ['Expandir Tabela', 'Análise do Veículo', 'Extrato do Evento'];

const TableHeader: React.FC<SortableTableHeaderProps> = ({
  column,
  label,
  dontFilterByColums,
  sortByColumn,
  sortDirection,
  handleSortChange,
}) => {
  const tableHeadClassNames = classNames('user-select-none', 'sort-column');
  const isSortable = !dontFilterByColums.includes(column);
  const shouldRenderLabel = !HIDDEN_LABELS.includes(label);

  return (
    <th
      key={column}
      className={tableHeadClassNames}
      {...(isSortable && handleSortChange ? { onClick: handleSortChange } : {})}
      data-field={column}
      data-sortby={column}
      title={label}
    >
      <span>
        {isSortable && column !== 'summary' && handleSortChange ? (
          <>
            {sortByColumn === column ? (
              <SortArrows direction={sortDirection || undefined} />
            ) : (
              <SortArrows />
            )}
            {shouldRenderLabel && <span>{label}</span>}
          </>
        ) : (
          shouldRenderLabel && <span>{label}</span>
        )}
      </span>
    </th>
  );
};

export default TableHeader;